import { Inject, Injectable } from '@angular/core';
import { ReCaptchaV3Service } from 'ngx-captcha';

@Injectable()
export class CaptchaService {
    constructor(
        @Inject('Environment') private readonly environment,
        private readonly reCaptchaV3Service: ReCaptchaV3Service,
    ) {}

    public executeV3(callback): void {
        this.reCaptchaV3Service.execute(this.environment.captcha.siteKey, this.environment.captcha.page, callback, {
            useGlobalDomain: false,
        });
    }
}
